import { render, staticRenderFns } from "./WizardOption.vue?vue&type=template&id=7cc0ea33&"
import script from "./WizardOption.vue?vue&type=script&lang=js&"
export * from "./WizardOption.vue?vue&type=script&lang=js&"
import style0 from "./WizardOption.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports